module.exports = __webpack_public_path__ + "img/sidebar_tippspiel_unternehmen.d8d2f124.png";